<template>
<div class="chapter">
<div class="inner_page">
<p class="p4"></p>
<p class="p0"><span class="t5"> </span></p>
<p class="p0"><span class="t5"> </span></p>
<p class="p0"><span class="t5"> </span></p>
<p class="p0"><span class="t5"> </span></p>
<p class="p0"><span class="t5"> </span></p>
<p class="p0"><span class="t5">Books by</span></p>
<p class="p0"><span class="t5">D.W. M</span><span class="t6">ARCHWELL</span></p>
<p class="p0"><span class="t5"> </span></p>
<p class="p0"><span class="t5">Good to Know</span></p>
<p class="p0"><span class="t5">An Earlier Heaven</span></p>
<p class="p0"><span class="t5"> </span></p>
<p class="p0"><span class="t5">Falling</span></p>
<p class="p0"><span class="t5">When Memory Fails</span></p>
<p class="p0"><span class="t5"> </span></p>
<p class="p0"><span class="t5">Sins of the Father</span></p>
<p class="p0"><span class="t5"> </span></p>
<p class="p0"><span class="t5"> </span></p>
<p class="p0"><span class="t5"> </span></p>
<p class="p0"><span class="t5"> </span></p>
<p class="p0"><span class="t5"> </span></p>
<p class="p0"><span class="t5">All available from</span></p>
<p class="p0"><span class="t5">D</span><span class="t6">REAMSPINNER</span><span class="t5"> P</span><span class="t6">RESS</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?82182a1c